@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.schoolFormContainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: variables.$std-margin-md;
}

.schoolAreaContainer,
.schoolDetailsContainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}

.schoolFullFieldContainer {
  width: 100%;
}

.schoolGenericFieldContainer {
  width: 50%;
}

.schoolFullWidthContainer {
  width: 100%;
}

.schoolFormButtonContainer {
  text-align: right;
}

.schoolGeocodeCheckBoxContainer,
.schoolMuteNotificationsCheckBoxContainer {
  display: flex;

  input {
    margin-left: variables.$std-margin-xxs;
  }

  p {
    margin-bottom: variables.$std-margin-lg;
  }
}

.schoolFormCancel {
  margin-right: variables.$std-margin-md;
}

.schoolFakeDistrictCheckBoxContainer {
  display: flex;
}

.schoolFakeDistrictCheckBox {
  flex-basis: 10%;
}

.schoolFakeDistrictCheckBoxDescription {
  flex-basis: 90%;
}
